import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "hooks"
    }}>{`Hooks`}</h1>
    <h1 {...{
      "id": "apply-filter-hook"
    }}>{`Apply Filter Hook`}</h1>
    <p>{`From v4.0.9 Reactive pro provided hooks(apply filter) support.
In this docs we will discuss about the hooks we have provided and which one can be useful for you,`}</p>
    <p>{`All the hooks are available in the below file`}</p>
    <pre><code parentName="pre" {...{}}>{`reactivepro -> app -> Graph.php &
reactivepro -> shortcodes -> preview.php
`}</code></pre>
    <p>{`In the above file you will see that we have added `}<inlineCode parentName="p">{`apply_filters`}</inlineCode>{` in many places.`}</p>
    <h3 {...{
      "id": "reactivepro_get_grid_all_data"
    }}>{`reactivepro_get_grid_all_data`}</h3>
    <p>{`The most important hook here is the `}<inlineCode parentName="p">{`reactivepro_get_grid_all_data`}</inlineCode>{` with this hook you can modify any data needed to show your grid search result.`}</p>
    <h3 {...{
      "id": "reactivepro_get_all_users"
    }}>{`reactivepro_get_all_users`}</h3>
    <p>{`With this hook you can modify the user data if you are using user search.`}</p>
    <h3 {...{
      "id": "reactivepro_get_user_grid_data"
    }}>{`reactivepro_get_user_grid_data`}</h3>
    <p>{`Can also be used to modify user data in the user search result.`}</p>
    <p>{`For now we think only this one is useful for the user. If you want to know more about any hook feel free to reach out to support here `}<a parentName="p" {...{
        "href": "https://redqsupport.ticksy.com/"
      }}>{`https://redqsupport.ticksy.com/`}</a></p>
    <h2 {...{
      "id": "hooks---faq"
    }}>{`Hooks -> FAQ`}</h2>
    <h3 {...{
      "id": "how-to-use-hook-to-show-woocommerce-price-in-the-grid"
    }}>{`How to use hook to show WooCommerce price in the grid?`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`// The filter callback function.
function example_callback($data)
{
    foreach ($data['allPosts'] as $key => $value) {
        $product = wc_get_product($value['ID']);
        $data['allPosts'][$key]['product_price_html'] = $product->get_price_html();
    }
    return $data;
}
add_filter('reactivepro_get_grid_all_data', 'example_callback', 10);
`}</code></pre>
    <p>{`Now in the grid template code just use`}</p>
    <pre><code parentName="pre" {...{}}>{`{{{post.product_price_html}}}
`}</code></pre>
    <h3 {...{
      "id": "how-to-use-reactive-pro-hooks"
    }}>{`How to use Reactive pro hooks?`}</h3>
    <blockquote>
      <p parentName="blockquote">{`NB: Check the hooks.md file inside the plugin files to know about hooks and where they are available.`}</p>
    </blockquote>
    <p>{`For example if you want to modify the image size, you can try it like below`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`function reactiveProCustomGridData($data){
    foreach ($data['allPosts'] as $key => $value) {
        $data['allPosts'][$key]['300image'] = "your_300_image_url";
    }
    return $data;
}
add_filter(
    'reactivepro_get_grid_all_data', // hook class
    'reactiveProCustomGridData', // wordpress function
    10,
    2
);
`}</code></pre>
    <p>{`Now in the grid template code you can use it like below inside the post loop`}</p>
    <pre><code parentName="pre" {...{}}>{`{{post.300image}}
`}</code></pre>
    <p>{`I want to use a hook for changing the order of categories in my search block.
do not want to order by name, but custom array order that I specify in a hook.
which hook should I use?`}</p>
    <p><strong parentName="p">{`=> ok I solved it, partially. If I order by slug, then I can rename the slugs with "01-***`}</strong>{`", 02-`}<strong parentName="p">{`*`}</strong>{`" and it won't affect the name of the filters on the frontend, but it will change the order.**`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`function reactivecatorder ($data){

 $data = wp_list_sort($data, "slug");
return $data;
}

add_filter(
    'reactivepro_get_all_terms', // hook class
    'reactivecatorder', // wordpress function
    10,
    2
);
`}</code></pre>
    <p>{`and another method, by custom order`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`function reactivecatorder  ($data){

// put custom order of term ids below
$order = array(37, 38, 39, 40, 47, 90, 71, 72, 73, 74, 75, 76, 77, 78, 87, 88, 89);
$array = $data;
usort($array, function ($a, $b) use ($order) {
    $pos_a = array_search($a['term_id'], $order);
    $pos_b = array_search($b['term_id'], $order);
    return $pos_a - $pos_b;
});
$data = $array;
return $data;
}

add_filter(
    'reactivepro_get_all_terms', // hook class
    'reactivecatorder', // wordpress function
    10,
    2
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      